import safeStructuredClone from '@/utils/clone'

const LANE_BASE_HEIGHT = 156
const LAST_LANE_EXTRA_HEIGHT = 15

// Recompute the full lane layout (index, height, y, laneAbove/laneBelow and node y) for a new
// lane order. Mirrors the recompute previously inlined in BpmnSwimLaneTitle.switchLanes so both
// the chevron move and the drag-reorder share identical math.
export const recomputeLaneLayout = (svgLanes, svgGraph, orderedLaneIds) => {
  const newSvgLanes = safeStructuredClone(svgLanes)
  const newSvgGraph = safeStructuredClone(svgGraph)

  orderedLaneIds.forEach((laneId, index) => {
    if (newSvgLanes[laneId]) {
      newSvgLanes[laneId].index = index
    }
  })

  // Calculate the required height for each lane based on its content.
  const laneHeightMultipliers = {}
  Object.values(newSvgGraph).forEach((node) => {
    laneHeightMultipliers[node.laneId] = Math.max(
      laneHeightMultipliers[node.laneId] || 1,
      node.offset + 1
    )
  })

  // Re-calculate all layout properties from scratch based on the new order and heights.
  const sortedLanes = Object.values(newSvgLanes).sort((a, b) => a.index - b.index)
  let laneAboveId = null

  sortedLanes.forEach((lane) => {
    const currentLane = newSvgLanes[lane.id]

    const heightMultiplier = laneHeightMultipliers[currentLane.id] || 1
    currentLane.height = LANE_BASE_HEIGHT * heightMultiplier

    currentLane.y = laneAboveId ? newSvgLanes[laneAboveId].y + newSvgLanes[laneAboveId].height : 0
    currentLane.laneAbove = laneAboveId

    if (laneAboveId) {
      newSvgLanes[laneAboveId].laneBelow = currentLane.id
    }
    laneAboveId = currentLane.id
  })

  if (laneAboveId) {
    newSvgLanes[laneAboveId].laneBelow = null
    newSvgLanes[laneAboveId].height += LAST_LANE_EXTRA_HEIGHT
  }

  Object.values(newSvgGraph).forEach((node) => {
    const parentLane = newSvgLanes[node.laneId]
    if (parentLane) {
      node.y = parentLane.y + 30 + node.offset * LANE_BASE_HEIGHT
    }
  })

  return { svgLanes: newSvgLanes, svgGraph: newSvgGraph }
}
